module.exports = __webpack_public_path__ + "static/media/BannerRegistroMobileES.3d143759.jpg";